module.exports = __webpack_public_path__ + "img/wxhome.410e20fe.jpg";